import { Injectable } from '@angular/core';
import { QuestionSet } from '../models/questionSet.model';
import { AngularFirestore, DocumentChangeAction } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private players: string[] = [];

  private selectedQuestionSet: QuestionSet = null;

  constructor(private firestore: AngularFirestore) { }

  addQuestionSet(questionSet: QuestionSet){
    return new Promise<any>((resolve, reject) => {
      this.firestore.collection('questionSets').add({
        name: questionSet.name,
        questions: questionSet.questions,
        owner: questionSet.owner
      }).then(res => {}, err => reject(err));
    });
  }

  updateQuestionSet(questionSet: QuestionSet){
    this.firestore.collection<QuestionSet>('questionSets').doc(questionSet.uid).set(questionSet);
  }

  deleteQuestionSet(questionSet: QuestionSet){
    return this.firestore.collection('questionSets').doc(questionSet.uid).delete();
  }

  getQuestionSets(): Observable<QuestionSet[]>{
    return this.firestore.collection<QuestionSet>('questionSets').valueChanges({idField: 'uid'});
  }

  async questionSetNameExists(name: string): Promise<boolean>{
    const snapshot = await this.firestore.collection('questionSets').ref.where('name', '==', name).get();
    if (snapshot.empty) {
      return false;
    }
    return true;
  }

  setPlayers(players: string[]){
    this.players = players;
  }

  getPlayers(){
    return this.players;
  }

  setSelectedQuestionSet(selectedQuestionSet: QuestionSet){
    this.selectedQuestionSet = selectedQuestionSet;
  }

  getSelectedQuestionSet(){
    return this.selectedQuestionSet;
  }
}
